document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('.msv2-card-swiper');
  if (!el) return;

  var totalSlides = el.querySelectorAll('.swiper-slide').length;

  var swiper = new Swiper('.msv2-card-swiper', {
    effect: 'cards',
    grabCursor: true,
    centeredSlides: true,
    loop: totalSlides > 2,
    cardsEffect: {
      perSlideOffset: 16,
      perSlideRotate: 4,
      rotate: true,
      slideShadows: false,
    },
  });


  // Slide counter
  var counterCurrent = document.querySelector('.msv2-slide-counter__current');
  var counterTotal = document.querySelector('.msv2-slide-counter__total');
  if (counterTotal) counterTotal.textContent = totalSlides;
  if (counterCurrent) counterCurrent.textContent = swiper.realIndex + 1;

  swiper.on('slideChange', function () {
    if (counterCurrent) counterCurrent.textContent = swiper.realIndex + 1;
  });

  // Swipe hint
  var hint = document.querySelector('.msv2-swipe-hint');
  if (!hint || totalSlides < 2) return;

  var nudgeTimeout = setTimeout(function () {
    hint.classList.add('msv2-swipe-hint--visible');

    var wrapper = el.querySelector('.swiper-wrapper');
    if (wrapper) {
      wrapper.style.transition = 'transform 0.4s ease';
      wrapper.style.transform = 'translateX(-30px)';
      setTimeout(function () {
        wrapper.style.transform = '';
        setTimeout(function () {
          wrapper.style.transition = '';
        }, 400);
      }, 400);
    }
  }, 1500);

  swiper.on('touchStart', dismissHint);
  swiper.on('slideChange', dismissHint);

  function dismissHint() {
    clearTimeout(nudgeTimeout);
    if (hint) {
      hint.classList.remove('msv2-swipe-hint--visible');
      hint.classList.add('msv2-swipe-hint--hidden');
    }
    swiper.off('touchStart', dismissHint);
    swiper.off('slideChange', dismissHint);
  }
});
